import { createSlice } from '@reduxjs/toolkit';
import { logout } from '../auth';

const initialState = {
  textSearch: '',
  headertextSearch: '',
  badgeSearch: '',
  questionSearch: '',
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setTextSearch: (state, action) => {
      state.textSearch = action.payload;
    },
    setHeaderTextSearch: (state, action) => {
      state.headertextSearch = action.payload;
    },
    setBadgeSearch: (state, action) => {
      state.badgeSearch = action.payload;
    },
    setQuestionSearch: (state, action) => {
      state.questionSearch = action.payload;
    },
  },
  extraReducers: {
    [logout]: (state) => initialState,
  },
});

export const getTextSearch = (state) => state.search.textSearch;
export const getHeaderTextSearch = (state) => state.search.headertextSearch;
export const getBadgeSearch = (state) => state.search.badgeSearch;
export const getQuestionSearch = (state) => state.search.questionSearch;

export const {
  setTextSearch,
  setHeaderTextSearch,
  setBadgeSearch,
  setQuestionSearch,
} = searchSlice.actions;

export default searchSlice.reducer;
